import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './List.scss';

const List = ({ content }) => (
	<div className={s.list}>
		<div className={s.list_inner} dangerouslySetInnerHTML={{ __html: purifier(content.rawText) }} />
	</div>
);

export default hot(module)(List);
